import { render, staticRenderFns } from "./CategoryExplore.vue?vue&type=template&id=c4d4fe4a"
import script from "./CategoryExplore.vue?vue&type=script&lang=js"
export * from "./CategoryExplore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports